import { render, staticRenderFns } from "./AbsentUsers.vue?vue&type=template&id=be3812cc&scoped=true&"
import script from "./AbsentUsers.vue?vue&type=script&lang=js&"
export * from "./AbsentUsers.vue?vue&type=script&lang=js&"
import style0 from "./AbsentUsers.vue?vue&type=style&index=0&id=be3812cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3812cc",
  null
  
)

export default component.exports